import { render, staticRenderFns } from "./iconHome.vue?vue&type=template&id=4dd05529&scoped=true&"
import script from "./iconHome.vue?vue&type=script&lang=js&"
export * from "./iconHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd05529",
  null
  
)

export default component.exports